import { EntitySidebarTile, EntitySidebarTileProps } from "./EntitySidebarTile/EntitySidebarTile";
import { CustomTypeEntityTypeOptionToIcon } from "../../../Customization/CustomTypes/CustomTypeRenderUtils";
import {
  CustomTypeTemplate,
  customTypeTemplateConstants,
  CustomTypeTemplateFilters,
  CustomTypeTemplateFiltersTranslator,
  CustomTypeTemplateSortingOptionsConsts,
} from "../../../api/CustomTypes/CustomTypeTemplates";
import { useMemo } from "react";
import { NotSet } from "../../misc/UIconstants";

export const CustomTypeTemplateTile = (
  props: EntitySidebarTileProps<CustomTypeTemplate, CustomTypeTemplateFilters>
) => {
  const defaultFilters: CustomTypeTemplateFilters = useMemo(
    () => ({ sortBy: [{ property: "NAME", sortDirection: "ASC" }], ...props.defaultFilters }),
    [props.defaultFilters]
  );
  return (
    <EntitySidebarTile<CustomTypeTemplate, CustomTypeTemplateFilters>
      rowLabel={(e) => <>{e.name}</>}
      rowInfo={(e) => <span title={e.description}>{e.description ?? NotSet}</span>}
      rowDate={(e) => (
        <div className="flex row-nowrap align-center gap-5">
          Entity type:
          <CustomTypeEntityTypeOptionToIcon entityType={e.entityType} />
          {e.entityType}
        </div>
      )}
      // controlsUnfolded={(props) => <CustomTypeTemplatePackgeSelectWidget {...props} />}
      {...props}
      entityConstants={customTypeTemplateConstants}
      orderByOptions={CustomTypeTemplateSortingOptionsConsts}
      translatorConsts={CustomTypeTemplateFiltersTranslator}
      defaultFilters={defaultFilters}
    />
  );
};

// const CustomTypeTemplatePackgeSelectWidget = ({
//   setFilters,
// }: {
//   setFilters: React.Dispatch<React.SetStateAction<CustomTypeTemplateFilters>>;
// }) => {
//   const { control, watch } = useForm<{ customTypeTemplatePackage: IEntityMinimalModel }>();

//   const formValue = watch("customTypeTemplatePackage");
//   const customTypeTemplatePackageIds = useMemo(
//     () =>
//       typeof formValue === "object" && !Array.isArray(formValue) && formValue !== null && !!formValue
//         ? [formValue.id]
//         : undefined,
//     [formValue]
//   );
//   useEffect(() => {
//     setFilters((f) => ({
//       ...f,
//       customTypeTemplatePackageIds,
//     }));
//   }, [customTypeTemplatePackageIds, setFilters]);

//   return (
//     <CustomTypeTemplatePackagesVirtualizedSelectForm
//       id="customTypeTemplatePackage"
//       control={control}
//       horizontal
//       label=""
//       hasLabel={false}
//       placeholder="Filter by package"
//     />
//   );
// };
